module.exports = __webpack_public_path__ + "img/eagle-right.d1840b0b.png";